<template><div><h1>VUX V2.1.1Rc.1 released</h1>
<h2><a href="/en/components/cell-box.html">CellBox</a></h2>
<ul><li>[feature] new component</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] Fix labelMarginRight #977 @wg5945</li>
</ul>
<h2><a href="/en/components/popup.html">Popup</a></h2>
<ul><li>[fix] Fix overflow-scrolling setting in safari #311 @linhaobin</li>
</ul>
<h2><a href="/en/components/radio.html">Radio</a></h2>
<ul><li>[feature] Support icon</li>
</ul>
<h2><a href="/en/components/sticky.html">Sticky</a></h2>
<ul><li>[fix] Fix wrong offset after transition between routes</li>
<li>[enhance] Set z-index #976 @olymk</li>
</ul>
<h2><a href="/en/components/tabbar.html">Tabbar</a></h2>
<ul><li>[fix] fix variable @tabbar-text-active-color #982 @marsal1212</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.1 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.1-88.vue?0d461bd8